import {fieldConditionHelper} from "@/form/helpers/field-conditionals.js";
import {rentMortgagePaymentStep} from "@/form/helpers/field-choices.js";

let steps = [
    // STEP 1 — Postal Code
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__postal_code__",
        fields: [
            {
                name: "postal_code",
                placeholder: 'A9A9A9',
                type: "text",
                value: null,
                validationRules: "required|postal",
                fieldOuterClass: "col-md-8 offset-md-2",
                hideIfHasValue: true,
                attrs: { maxlength: 7 },
            },
        ],
    },
    // STEP 2 — CC Debt Amount
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__cc_debt_amount__',
        fields: [
            {
                name: 'cc_debt_amount',
                placeholder: '2500',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_debt_amounts_2500_less__", "value":"2500" },
                    { "text":"__opt_debt_amounts_2501_5000__", "value":"5000" },
                    { "text":"__opt_debt_amounts_5001_10000__", "value":"7500" },
                    { "text":"__opt_debt_amounts_10001_15000__", "value":"10000" },
                    { "text":"__opt_debt_amounts_15001_20000__", "value":"15000" },
                    { "text":"__opt_debt_amounts_20001_25000__", "value":"20000" },
                    { "text":"__opt_debt_amounts_25000_more__", "value":"25000" },
                    { "text":"__opt_debt_no_cc_debt__", "value":"0" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    // STEP 3 — Unsecured Debt Amount
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__unsecured_debt_amount__',
        textTop: '__unsecured_debt_amount_definition__',
        fields: [
            {
                name: 'unsecured_debt_amount',
                placeholder: '2500',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: (app) => {
                    const defaultChoices = [
                        { "text": "__opt_debt_amounts_2500_less__", "value": "2500" },
                        { "text": "__opt_debt_amounts_2501_5000__", "value": "5000" },
                        { "text": "__opt_debt_amounts_5001_10000__", "value": "7500" },
                        { "text": "__opt_debt_amounts_10001_15000__", "value": "10000" },
                        { "text": "__opt_debt_amounts_15001_20000__", "value": "15000" },
                        { "text": "__opt_debt_amounts_20001_25000__", "value": "20000" },
                        { "text": "__opt_debt_amounts_25000_more__", "value": "25000" },
                    ];

                    return app.cc_debt_amount && app.cc_debt_amount > 0
                        ? [...defaultChoices, { "text": "__opt_debt_no_unsecured_debt__", "value": "0" }]
                        : defaultChoices;
                },
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    // STEP 4 — Monthly Income
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__monthly_income__",
        fields: [
            {
                name: 'monthly_income',
                placeholder: '2500',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_1500_less__", "value":"1500" },
                    { "text":"__opt_1501_2000__", "value":"2000" },
                    { "text":"__opt_2001_3000__", "value":"3000" },
                    { "text":"__opt_3001_4000__", "value":"4000" },
                    { "text":"__opt_4001_5000__", "value":"5000" },
                    { "text":"__opt_5000_more__", "value":"5500" },
                ],
                attrs: {
                    maxlength: 5
                },
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    // STEP 5 — Own Home
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__own_home__",
        fields: [
            {
                name: 'own_home',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    // STEP 6 — Rent/mortgage payment (one-tap radio), then property fields for homeowners only
    rentMortgagePaymentStep(),
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__living_situation__",
        fields: [
            {
                label: '__property_value__',
                name: 'property_value',
                placeholder: '650000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric|max:7',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 7
                },
                hideIfHasValue: true,
                hideIfCondition: (app) => {
                    return fieldConditionHelper.homeOwner(app);
                },
            },
            {
                label: '__property_mortgage__',
                name: 'property_mortgage',
                placeholder: '300000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric|propertyMortgage|max:7',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 7
                },
                hideIfHasValue: true,
                hideIfCondition: (app) => {
                    return fieldConditionHelper.homeOwner(app) || fieldConditionHelper.noMortgage(app);
                },
            },
        ],
        // Owners only: renters answered everything on the rent step.
        hideIfCondition: fieldConditionHelper.homeOwner,
    },
    // STEP 7 — Credit Situation
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__in_credit_situation__",
        fields: [
            {
                name: 'in_credit_situation',
                placeholder: '__select__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_in_credit_situation_good__", "value": "good"},
                    {"text": "__opt_in_credit_situation_fair__", "value": "fair"},
                    {"text": "__opt_in_credit_situation_low__", "value": "low"},
                    // {"text": "__opt_in_credit_situation_cp__", "value":"in_consumer_proposal"},
                    // {"text": "__opt_in_credit_situation_bk__", "value":"in_bankruptcy"},
                    {"text": "__opt_in_credit_situation_unknown__", "value": "unknown"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    // STEP 8 — In Bankruptcy
    {
        hideIfCondition: (app) => {
            return !!app.in_credit_situation && app.in_credit_situation === "in_bankruptcy";
        },
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__in_bankruptcy__",
        fields: [
            {
                name: 'in_bankruptcy',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    // STEP 9 — In DMP
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__in_dmp__",
        fields: [
            {
                name: 'in_dmp',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    // STEP 10 — In Consumer Proposal
    {
        hideIfCondition: (app) => {
            return !!app.in_credit_situation && app.in_credit_situation === "in_consumer_proposal";
        },
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__in_consumer_proposal__",
        fields: [
            {
                name: 'in_consumer_proposal',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    // STEP 11 — Contact Info
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__how_to_contact__",
        fields: [
            {
                label: '__first_name__',
                name: 'first_name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__last_name__',
                name: 'last_name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__email_address__',
                name: 'email',
                type: 'text',
                value: null,
                validationRules: 'required|email',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                }
            },
            {
                label: "__address_city__",
                name: "city",
                type: "text",
                value: null,
                validationRules: "required",
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: true,
                attrs: { maxlength: 50 },
            },
            {
                label: "__province__",
                name: "state",
                type: "select",
                value: null,
                validationRules: "required",
                fieldOuterClass: "col-md-8 offset-md-2",
                choices: [
                    {"value":"AB", "text":"ALBERTA"},
                    {"value":"BC", "text":"BRITISH COLUMBIA"},
                    {"value":"MB", "text":"MANITOBA"},
                    {"value":"NB", "text":"NEW BRUNSWICK"},
                    {"value":"NL", "text":"NEWFOUNDLAND AND LABRADOR"},
                    {"value":"NS", "text":"NOVA SCOTIA"},
                    {"value":"ON", "text":"ONTARIO"},
                    {"value":"PE", "text":"PRINCE EDWARD ISLAND"},
                    {"value":"QC", "text":"QUEBEC"},
                    {"value":"SK", "text":"SASKATCHEWAN"},
                    {"value":"NT", "text":"NORTHWEST TERRITORIES"},
                    {"value":"NU", "text":"NUNAVUT"},
                    {"value":"YT", "text":"YUKON"},
                ],
                hideIfHasValue: true,
            },
            {
                label: '__phone_number__',
                name: 'phone_number',
                type: 'text',
                value: null,
                validationRules: 'required|canadianPhone',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: false,
                textBottom: '__phone_number_sms_results__'
            },
        ],
        textBottomBelowActionButtons: "__credit_history_authorization_1__"
    },
];

export default steps;
